import visibilitat1 from './visibilitat-01.svg';
import visibilitat2 from './visibilitat-02.svg';
import visibilitat3 from './visibilitat-03.svg';
import visibilitat4 from './visibilitat-04.svg';
import visibilitat5 from './visibilitat-05.svg';

export default {
	visibilitat1,
	visibilitat2,
	visibilitat3,
	visibilitat4,
	visibilitat5
};



// WEBPACK FOOTER //
// ./src/images/visibilitat/index.js